var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-card-line",class:{ 'is-strong': _vm.strong }},[_c('span',{staticClass:"m-card-line__label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"m-card-line__value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }